import {Assignees} from './Assignees'
import {CondensedReviewers} from './reviewers/CondensedReviewers'
import {SidebarSection} from './SidebarSection'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {Suspense} from 'react'

// NOTE: this Overview info only works on the /overview page due to how its
// wired up with dataload. This is an intentional tradeoff while deciding if its worth having
// this panel at all
export function OverviewInfoContent() {
  return (
    <ErrorBoundary boundaryName="OverviewInfoPanel">
      <Suspense fallback={<div>Loading...</div>}>
        <OverviewInfo />
      </Suspense>
    </ErrorBoundary>
  )
}

function OverviewInfo() {
  return (
    <div className="d-flex flex-column gap-3">
      <SidebarSection title="Reviewers">
        <CondensedReviewers />
      </SidebarSection>

      <SidebarSection title="Assignees">
        <Assignees />
      </SidebarSection>
    </div>
  )
}
